import PropTypes from 'prop-types'
import React, { useState, useEffect } from "react"
import { CardTitle, Col, Label, Modal, ModalBody, ModalHeader, Row, Input, InputGroup } from "reactstrap"
import { useSelector, useDispatch } from "react-redux";
import Select from "react-select";
import CurrencyFormat from 'react-currency-format';
import Flatpickr from "react-flatpickr";

const ModalApproval = ({ show, onSubmit, onCancel, data }) => {
    const dispatch = useDispatch()
    const dataSource = data
    const [dataSubmit, setDataSubmit] = useState(dataSource)
    const [isSubmit, setIsSubmit] = useState(false)
    const [selectedCompany, setSelectedCompany] = useState(null)
    const [selectedAccount, setSelectedAccount] = useState(null)
    const [selectedAccountNumber, setSelectedAccountNumber] = useState(null)
    const [selectedPeriod, setSelectedPeriod] = useState(null)
    const [selectedType, setSelectedType] = useState(null)
    const [selectedAdjustment, setSelectedAdjustment] = useState(null)
    const [selectedFiscal, setSelectedFiscal] = useState(null)
    const [optionAccountNumber, setOptionAccountNumber] = useState(null)
    const [optionAccount, setOptionAccount] = useState(null)
    const [optionPeriod, setOptionPeriod] = useState(null)
    const optionType = [
        { label: "CREDIT", value: "credit" },
        { label: "DEBIT", value: "debit" },
    ]
    const optionYesNo = [
        { label: "Yes", value: true },
        { label: "No", value: false },
    ]

    const { companies, accountNumbers, accounts, periods } = useSelector(state => ({
        companies: state.Company.companies,
        accountNumbers: state.AccountNumber.listAccountNumber,
        accounts: state.Account.listAccount,
        periods: state.Period.periods,
    }))

    useEffect(() => {
        if (accountNumbers) {
            setOptionAccountNumber(accountNumbers.map(item => {
                return { label: item.name, value: item.id }
            }))
        }
    }, [accountNumbers])

    useEffect(() => {
        if (accounts) {
            setOptionAccount(accounts.map(item => {
                return { label: item.name, value: item.id }
            }))
        }
    }, [accounts])

    useEffect(() => {
        if (periods) {
            setOptionPeriod(periods.map(item => {
                return { label: item.name, value: item.id }
            }))
        }
    }, [periods])

    const valid = () => {
        return dataSource?.companyId != null &&
            dataSource?.date != null && dataSource?.date.trim() != "" &&
            dataSource?.accountId != null &&
            dataSource?.accountNumberId != null &&
            dataSource?.type != null && dataSource?.type.trim() != "" &&
            dataSource?.remarks != null && dataSource?.remarks.trim() != "" &&
            dataSource?.nominal != null && dataSource?.nominal > 0 &&
            dataSource?.periodId != null &&
            dataSource?.adjustment != null &&
            dataSource?.fiscal != null
    }

    useEffect(() => {
        setIsSubmit(false)
        setSelectedAccount(null)
        setSelectedAccountNumber(null)

        if (companies) {
            var temp = companies.filter(s => s.id == dataSource?.companyId)
            if (temp.length > 0) {
                setSelectedCompany({ label: temp[0].name, value: temp[0].id })
            }
        }
        if (accountNumbers) {
            var temp = accountNumbers.filter(s => s.id == dataSource?.accountNumberId)
            if (temp.length > 0) {
                setSelectedAccountNumber({ label: temp[0].name, value: temp[0].id })
            }
            else {
                setSelectedAccountNumber(null)
            }
        }
        if (accounts) {
            var temp = accounts.filter(s => s.id == dataSource?.accountId)
            if (temp.length > 0) {
                setSelectedAccount({ label: temp[0].name, value: temp[0].id })
            }
            else {
                setSelectedAccount(null)
            }
        }
        if (periods) {
            var temp = periods.filter(s => s.id == dataSource?.periodId)
            if (temp.length > 0) {
                setSelectedPeriod({ label: temp[0].name, value: temp[0].id })
            }
            else {
                setSelectedPeriod(null)
            }
        }

        var tempType = optionType.filter(s => s.value == dataSource?.type?.toLowerCase())
        if (tempType.length > 0) {
            setSelectedType(tempType[0])
        }
        else {
            setSelectedType(null)
        }

        var tempAdjustment = optionYesNo.filter(s => s.value == dataSource?.adjustment)
        if (tempAdjustment.length > 0) {
            setSelectedAdjustment(tempAdjustment[0])
        }
        else {
            setSelectedAdjustment(null)
        }

        var tempFiscal = optionYesNo.filter(s => s.value == dataSource?.fiscal)
        if (tempFiscal.length > 0) {
            setSelectedFiscal(tempFiscal[0])
        }
        else {
            setSelectedFiscal(null)
        }
    }, [show])

    useEffect(() => {
        if (data) {
            setDataSubmit(Object.assign({}, data))
        }
    }, [data])

    function handleDateChange(e) {
        const dd = e[0].getDate().toString();
        const mm = e[0].getMonth() + 1;
        const yyyy = e[0].getFullYear();
        if (dataSubmit) {
            dataSubmit.date = String(yyyy).padStart(2, '0') + "-" + String(mm).padStart(2, '0') + "-" + String(dd).padStart(2, '0')
        }
    }

    function handleSelectAccount(val) {
        if (dataSubmit) {
            dataSubmit.accountId = val ? val.value : null
            setSelectedAccount(val)
        }
    }

    function handleSelectAccountNumber(val) {
        if (dataSubmit) {
            dataSubmit.accountNumberId = val ? val.value : null
            setSelectedAccountNumber(val)
        }
    }

    function handleSelectPeriod(val) {
        if (dataSubmit) {
            dataSubmit.periodId = val ? val.value : null
            setSelectedPeriod(val)
        }
    }

    function handleSelectType(val) {
        if (dataSubmit) {
            dataSubmit.type = val ? val.value : null
            setSelectedType(val)
        }
    }

    function handleSelectAdjustment(val) {
        if (dataSubmit) {
            dataSubmit.adjustment = val ? val.value : null
            setSelectedAdjustment(val)
        }
    }

    function handleSelectFiscal(val) {
        if (dataSubmit) {
            dataSubmit.fiscal = val ? val.value : null
            setSelectedFiscal(val)
        }
    }

    function handleNominalChange(val) {
        if (dataSubmit) {
            dataSubmit.nominal = isNaN(val.floatValue) ? 0 : val.floatValue
        }
    }

    function handleRemarksChange(val) {
        if (dataSubmit) {
            dataSubmit.remarks = val
        }
    }


    return (
        <Modal isOpen={show} toggle={onCancel} centered={true} size={"xl"}>
            <ModalHeader>
                <CardTitle>Approve Client Transaction</CardTitle>
            </ModalHeader>
            <ModalBody className="p-3">
                <Row className="mb-3">
                    <Col>
                        <div>
                            <Label>Company</Label><Label className="text-danger">*</Label>
                            <Select
                                value={selectedCompany}
                                isClearable={false}
                                isDisabled={true}
                                className="select2-selection"
                                menuPosition="fixed"
                            />
                        </div>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <Label>Date</Label><Label className="text-danger">*</Label>
                        <InputGroup>
                            <Flatpickr
                                className={"form-control d-block"}
                                placeholder="Select Date"
                                options={{
                                    dateFormat: "Y-m-d"
                                }}
                                onChange={e => handleDateChange(e)}
                                value={dataSource?.date}
                            />
                        </InputGroup>
                    </Col>
                    <Col>
                        <div>
                            <Label>Account Number</Label><Label className="text-danger">*</Label>
                            <Select
                                value={selectedAccountNumber}
                                onChange={(val) => {
                                    handleSelectAccountNumber(val)
                                }}
                                options={optionAccountNumber}
                                isClearable={false}
                                isDisabled={true}
                                className="select2-selection"
                                menuPosition="fixed"
                            />
                            {isSubmit && !selectedAccountNumber && <small className='text-danger'>Value is required.</small>}
                        </div>
                    </Col>
                    <Col>
                        <div>
                            <Label>Account</Label><Label className="text-danger">*</Label>
                            <Select
                                value={selectedAccount}
                                onChange={(val) => {
                                    handleSelectAccount(val)
                                }}
                                options={optionAccount}
                                isClearable={false}
                                className="select2-selection"
                                menuPosition="fixed"
                            />
                            {isSubmit && !selectedAccount && <small className='text-danger'>Value is required.</small>}
                        </div>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <div>
                            <Label>Type</Label><Label className="text-danger">*</Label>
                            <Select
                                value={selectedType}
                                onChange={(val) => {
                                    handleSelectType(val)
                                }}
                                options={optionType}
                                isClearable={true}
                                className="select2-selection"
                                menuPosition="fixed"
                            />
                            {isSubmit && !selectedType && <small className='text-danger'>Value is required.</small>}
                        </div>
                    </Col>
                    <Col>
                        <div>
                            <Label>Remarks</Label><Label className="text-danger">*</Label>
                            <Input
                                defaultValue={dataSource?.remarks}
                                type="text"
                                className="form-control"
                                onChange={e => {
                                    handleRemarksChange(e.target.value)
                                }}
                                placeholder={'Enter ...'}
                            />
                            {isSubmit && dataSubmit && (!dataSubmit.remarks || dataSubmit.remarks.trim() == "") && <small className='text-danger'>Value is required.</small>}
                        </div>
                    </Col>
                    <Col>
                        <div>
                            <Label>Nominal</Label><Label className="text-danger">*</Label>
                            <CurrencyFormat value={dataSource?.nominal} thousandSeparator={'.'} decimalSeparator={','} decimalScale={0}
                                onValueChange={(values) => {
                                    handleNominalChange(values)
                                }}
                                customInput={Input} className="text-end" />
                            {isSubmit && dataSubmit && (!dataSubmit.nominal || dataSubmit.nominal <= 0) && <small className='text-danger'>Value is required and minimum 1.</small>}
                        </div>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <div>
                            <Label>Period</Label><Label className="text-danger">*</Label>
                            <Select
                                value={selectedPeriod}
                                onChange={(val) => {
                                    handleSelectPeriod(val)
                                }}
                                options={optionPeriod}
                                isClearable={false}
                                className="select2-selection"
                                menuPosition="fixed"
                            />
                            {isSubmit && !selectedPeriod && <small className='text-danger'>Value is required.</small>}
                        </div>
                    </Col>
                    <Col>
                        <div>
                            <Label>Adjustment</Label><Label className="text-danger">*</Label>
                            <Select
                                value={selectedAdjustment}
                                onChange={(val) => {
                                    handleSelectAdjustment(val)
                                }}
                                options={optionYesNo}
                                isClearable={true}
                                className="select2-selection"
                                menuPosition="fixed"
                            />
                        </div>
                        {isSubmit && !selectedAdjustment && <small className='text-danger'>Value is required.</small>}
                    </Col>
                    <Col>
                        <div>
                            <Label>Fiscal</Label><Label className="text-danger">*</Label>
                            <Select
                                value={selectedFiscal}
                                onChange={(val) => {
                                    handleSelectFiscal(val)
                                }}
                                options={optionYesNo}
                                isClearable={true}
                                className="select2-selection"
                                menuPosition="fixed"
                            />
                            {isSubmit && !selectedFiscal && <small className='text-danger'>Value is required.</small>}
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="text-end mt-3">
                            <button
                                type="button"
                                className="btn btn-success ms-2"
                                onClick={() => {
                                    setIsSubmit(true)
                                    onSubmit(dataSubmit)
                                }}
                                disabled={valid()}>
                                Submit
                            </button>
                            <button
                                type="button"
                                className="btn btn-danger ms-2"
                                onClick={onCancel}>
                                Cancel
                            </button>
                        </div>
                    </Col>
                </Row>
            </ModalBody>
        </Modal>
    )
}

ModalApproval.propTypes = {
    onSubmit: PropTypes.func,
    onCancel: PropTypes.func,
    show: PropTypes.any,
    data: PropTypes.any,
}

export default ModalApproval
